import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'

import Box from '../component/Box/Box'
import Page from '../component/Page/Page'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import BizLocationSelector from '../component/BizLocation/BizLocationSelector'
import ProductTypeSelector from '../productType/component/ProductTypeSelector'
import InventoryService from '../services/InventoryService'
import Notify from '../services/Notify'
import FormButtons from '../component/Form/FormButtons'
import RadioWithLabel from '../component/Form/RadioWithLabel'

function InventoryFormScreen({ history }) {
  const [bizLocation, setBizLocation] = useState(null)
  const [productTypes, setProductTypes] = useState([])
  const [isFullInventory, setIsFullInventory] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const inventoryService = new InventoryService()

  const createInventory = async (event) => {
    event.preventDefault()
    try {
      setIsLoading(true)
      const inventoryCreateBody = {
        bizLocation,
        productTypes,
        full: productTypes.length === 0
      }
      await Notify.promise(inventoryService.createInventory(inventoryCreateBody), {
        pending: 'Criando inventário...',
        success: 'Inventário criado!',
        error: 'Houve um erro ao criar o inventário.',
      })
      history.push('/list/inventories')
    } catch (error) {
      console.log(error, error.response.data.message)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSetProductTypes = (productTypes) => {
    setProductTypes(productTypes.map(x => ({ id: x.id })))
  }

  const handleSetBizLocation = (bizLocation) => {
    setBizLocation(bizLocation)
  }

  const breadcrumbs = [
    <BreadcrumbItem title="Lista de inventários" to="/list/inventories" key={1} />,
    <BreadcrumbItem title="Novo inventário" key={2} />
  ]
  
  useEffect(() => {
    Notify.dismissAll()
  }, [])

  return (
    <Page title="Novo inventário" breadcrumbs={breadcrumbs}>
      <Box title="Dados do inventário">
        <Form onSubmit={createInventory}>
          <Row className="mt-1 mb-2 w-50 align-items-center">
            <Col md={6}>
              <RadioWithLabel
                defaultValue={isFullInventory}
                label="Inventário completo"
                name="inventoryType"
                value={isFullInventory}
                onChange={() => setIsFullInventory(true)}
              />
            </Col>
            <Col md={6}>
              <RadioWithLabel
                defaultValue={isFullInventory}
                label="Inventário parcial"
                name="inventoryType"
                value={!isFullInventory}
                onChange={() => setIsFullInventory(false)}
              />
            </Col>
          </Row>
          <Row className="align-items-center mb-4">
            <Col md={6}>
              <BizLocationSelector required onChange={handleSetBizLocation} />
            </Col>
            {
              !isFullInventory && (
                <Col md={6}>
                  <ProductTypeSelector multiple required setValue={handleSetProductTypes} />
                </Col>
              )
            }
          </Row>
          <FormButtons history={history} isLoading={isLoading} saveButtonTitle="CRIAR" />
        </Form>
      </Box>
    </Page>
  )
}

export default InventoryFormScreen



// WEBPACK FOOTER //
// ./src/Inventory/InventoryFormScreen.js